import React, { useState } from 'react';

import { Link } from 'react-router-dom';

import LockUrl from '@pkg/assets/images/Lock.png';
import { use2FA } from '@pkg/hooks';

import { useAuthTokens } from '@app/store/zustand/auth/useAuthTokens';

import { Typography } from '../../DesignSystem';
import SecurityCodeInput, { SecurityCodeInputVariants } from '../../Input/SecurityCodeInput';
import { DepButton } from '../../deprecated';
import { Container, EmojiImage, FormGroup, FormRow, PrimaryCopySection, Section } from '../Web3Auth.style';
import { Web3AuthSteps } from '../Web3Auth.types';
import { useWeb3AuthContext } from '../context';

export function TwoFactorAuth() {
    const { setCurrentStep } = useWeb3AuthContext();
    const [code, setCode] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const twoFACodeDigitCount = 6;
    const tokens = useAuthTokens((rootState) => rootState.token);
    const { login2FA } = use2FA();

    async function handleLogin() {
        if (!tokens) {
            setCurrentStep(Web3AuthSteps.Entry);
            return;
        }
        setIsLoading(true);
        const twoFATokens = await login2FA({ code, refreshToken: tokens.refresh_token });

        if (!twoFATokens || !twoFATokens.ok) {
            setIsLoading(false);
        }
    }

    return (
        <Container>
            <Section className="hide-on-tablet">
                <EmojiImage src={LockUrl} />
            </Section>

            <PrimaryCopySection>
                <Typography type="headline" size={40}>
                    2-Step Verification
                </Typography>
                <Typography type="paragraph" size={18} faded={true}>
                    Enter the 6-digit code generated by your TOTP/authenticator app{' '}
                </Typography>
            </PrimaryCopySection>

            <Section>
                <SecurityCodeInput
                    setCompleteCode={(code) => setCode(code)}
                    digitCount={twoFACodeDigitCount}
                    variant={SecurityCodeInputVariants.MidSpaced}
                    digitOnly
                    onAutoSubmit={handleLogin}
                />
            </Section>

            <Section>
                <FormGroup>
                    <FormRow>
                        <DepButton
                            variant="glow"
                            disabled={code.length !== twoFACodeDigitCount}
                            onClick={handleLogin}
                            loading={isLoading}
                        >
                            Log in
                        </DepButton>
                    </FormRow>
                    <FormRow>
                        <Link to="#2fa-lost">Lost your authentication device?</Link>
                    </FormRow>
                </FormGroup>
            </Section>
        </Container>
    );
}
